<template>

<core-modal v-on:close="onClose" :icon="(is.selected && !data.group) ? 'caret-left' : false" :loading="is.loading && !is.initialised">

	<template v-slot:head>

		Group subdomain

	</template>

	<template v-slot:default>

        <div class="groups-empty" v-if="!groups.length">You have not created any groups yet.</div>

        <template v-if="groups.length">

            <div v-for="(item, index) in groups" :key="index" class="group" :class="{'is-selected': is.selected === item.id && !data.group, 'is-disabled': item.subdomain}" v-tooltip="'Click to select group'" v-on:click="onGroupClick(item)">

                <div class="group-name">
                    <span>{{ item.name }}</span>
                    <i class="fa-solid fa-globe-pointer" v-if="item.subdomain" />
                    <i class="fa-solid fa-check" v-if="is.selected === item.id" />
                </div>

                <div class="group-metrics">
                
                    <div class="group-metrics-item">
                        <span>{{ item.count.users }}</span>
                        <i class="fa-solid fa-users" />
                    </div>
                
                    <div class="group-metrics-item">
                        <span>{{ item.count.collection }}</span>
                        <i class="fa-solid fa-rectangle-vertical-history" />
                    </div>
                
                    <div class="group-metrics-item">
                        <span>{{ item.count.ratings }}</span>
                        <i class="fa-solid fa-star" />
                    </div>
                
                    <div class="group-metrics-item">
                        <span>{{ item.count.plays }}</span>
                        <i class="fa-solid fa-dice-three" />
                    </div>
                
                </div>

            </div>

        </template>

        <template v-if="is.selected">

            <p>All subdomains will be reviewed prior to being activated. Please do not use inappropriate language or anything that could be confused with an official geekgroup subdomain or another user. Once approved, you cannot change subdomain for at least 7 days.</p>

            <core-form-input-textbox :autofocus="true" maxlength="24" name="name" v-on:validate="validate" placeholder="Enter subdomain" v-model="model.name" />
            
        </template>

    </template>

	<template v-slot:foot>

        <template v-if="is.selected">

            <core-button theme="blue" :loading="is.loading" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="!isPending">Send Request</core-button>
            <core-button theme="blue" :loading="is.loading" :disabled="!isValid" v-on:click.native="onConfirmClick" v-if="isPending">Update Request</core-button>
            <core-button theme="red" :loading="is.cancelling" v-on:click.native="onCancelClick" v-if="isPending">Cancel Request</core-button>
            <core-button theme="red" :loading="is.cancelling" v-on:click.native="onCancelClick" v-if="isAccepted">Remove Subdomain</core-button>

        </template>

	</template>

</core-modal>

</template>

<script>

import Vue from 'vue'

export default {

	data: function() {

		return {

			is: {
                selected: false,
				loading: false,
                initialised: false,
                cancelling: false
			},
                
            model: {
                name: ''
            },

            data: {}

		}

	},

    created: function() {

        this.load()

    },

    computed: {

        isValid: function() {

            return this.model.name.length > 2

        },

		groups: function() {

			return (this.is.selected) ? this.$_.where(this.$store.getters['session/groups'], {
                id: this.is.selected
            }) : this.$_.where(this.$store.getters['session/groups'], {
                owner: this.$store.getters['session/user/id']
            })

		},

        isPending: function() {

            return (this.data.group) ? !this.data.group.status : false

        },

        isAccepted: function() {

            return (this.data.group) ? this.data.group.status : false

        }

    },

	methods: {

        load: function() {

            this.is.loading = true
            
            this.$api.get('session/subdomains').then(function(json) {

                if (json.group) {

                    this.model.name = json.group.value
                    this.is.selected = json.group.recipient

                }

                Vue.set(this, 'data', json)

                this.is.loading = false
                this.is.initialised = true

            }.bind(this), function() {
                
                this.$emit('close')

            }.bind(this))

        },

        onConfirmClick: function() {

            this.is.loading = true
            
            this.$api.post('session/subdomains', {
                type: 'group',
                group: this.is.selected,
                value: this.model.name
            }).then(function(json) {

                if (json.group) this.$store.commit('session/group', json.group)

                this.$pubsub.$emit('session.patreon.subdomains')

                this.$emit('close')

            }.bind(this), function() {
                
                this.$notify({
					message: 'Sorry, this subdomain has been taken.',
					type: 'error'
				})

                this.is.loading = false

            }.bind(this))

        },
        
        onCancelClick: function() {

            this.is.cancelling = true
            
            this.$api.delete('session/subdomains', {
                type: 'group'
            }).then(function(json) {

                if (json.group) this.$store.commit('session/group', json.group)

                this.$pubsub.$emit('session.patreon.subdomains')

                this.$emit('close')

            }.bind(this), function() {
                
                this.$pubsub.$emit('session.patreon.subdomains')

                this.$emit('close')

            }.bind(this))

        },

        onGroupClick: function(group) {

            this.model.name = ''
            this.is.selected = group.id

        },

		onClose: function() {

            if (this.is.selected && !this.data.group) {

                this.is.selected = false

            } else {

                this.$emit('close')

            }

		}

	}

}

</script>

<style scoped>

.group {
    margin-bottom: 20px;
    display: block;
    cursor: pointer;
}

.group.is-disabled {
    opacity: 0.25;
    pointer-events: none;
}

.groups-empty {
    color: #fff;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    font-weight: 500;
    padding: 20px 0px;
}

.group:last-child {
    margin-bottom: 0px;
}

.group-name {
    border-radius: 4px;
    padding: 10px 50px 10px 10px;
    font-size: 16px;
    font-weight: 500;
    color: #fff;
    background-color: rgba(0, 0, 0, 0.25);
}

.group.is-selected .group-name {
    background-color: #48bb6d;
}

.group:hover .group-name {
    background-color: rgba(0, 0, 0, 0.45);
}

.group.is-selected:hover .group-name {
    background-color: #48bb6d;
}

.group-name i.fa-check {
    position: absolute;
    right: 15px;
    top: 0px;
    line-height: 36px;
}

.group-name i.fa-globe-pointer {
    position: absolute;
    right: 15px;
    top: 6px;
    color: #fff;
    background-color: #48bb6d;
    border-radius: 50%;
    width: 24px;
    font-size: 14px;
    height: 24px;
    text-align: center;
    line-height: 24px;
}

.group-metrics {
    display: grid;
    margin-top: 4px;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 4px;
}

.group-metrics-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: rgba(255, 255, 255, 0.25);
    justify-content: center;
    padding: 10px 0px;
    border-radius: 4px;
}

.group-metrics-item i {
    font-size: 14px;
    color: #fff;
    opacity: 0.75;
}

.group-metrics-item span {
    font-size: 18px;
    color: #fff;
    font-weight: 400;
    margin-bottom: 8px;
}

</style>